import Associate from './AssociateDetailPage';

export default Associate;
